export function isStandupDate(value: unknown): value is string {
  return typeof value === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(value)
    && !Number.isNaN(Date.parse(value)) && new Date(value).toISOString().slice(0, 10) === value
}

export function workspaceDate(timezone: string | null | undefined, now = new Date()): string {
  try {
    const parts = new Intl.DateTimeFormat('en-US', {
      timeZone: timezone || 'UTC', year: 'numeric', month: '2-digit', day: '2-digit',
    }).formatToParts(now)
    const part = (type: string) => parts.find(p => p.type === type)?.value
    return `${part('year')}-${part('month')}-${part('day')}`
  } catch {
    return now.toISOString().slice(0, 10)
  }
}

// A reminder reply belongs to that session even if the form crosses midnight.
export function standupSubmissionDate(timezone: string | null | undefined, sessionDate: unknown, formDate: unknown, now = new Date()): string {
  return isStandupDate(sessionDate) ? sessionDate : isStandupDate(formDate) ? formDate : workspaceDate(timezone, now)
}
